import { useEffect } from 'react'

export function useReferenceStyles() {
  useEffect(() => {
    void import('./prototypeStyles')
  }, [])
}
